import { render, staticRenderFns } from "./SwMsgConfigEditor.vue?vue&type=template&id=6683b96d&scoped=true&"
import script from "./SwMsgConfigEditor.vue?vue&type=script&lang=js&"
export * from "./SwMsgConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683b96d",
  null
  
)

export default component.exports